import { useEffect, useRef, useState } from "react";
import { FUEL_GOAL } from "./data";

export const Ship = () => (
  <svg width="74" height="30" viewBox="0 0 74 30" fill="none" className="drop-shadow-[0_0_10px_rgba(53,224,240,0.45)]">
    <g className="flame">
      <path d="M22 15 L2 10 Q10 15 2 20 Z" fill="#ff8c46" opacity="0.95" />
      <path d="M22 15 L9 12 Q13 15 9 18 Z" fill="#ffd28f" />
    </g>
    <path d="M24 8 h26 l14 7 -14 7 h-26 Z" fill="#c8d6ee" />
    <path d="M24 8 h26 l14 7 h-40 Z" fill="#e8f0fc" />
    <rect x="20" y="5" width="6" height="20" rx="2" fill="#8fa5c9" />
    <circle cx="50" cy="15" r="4" fill="#0b1120" stroke="#35e0f0" strokeWidth="1.6" />
    <circle cx="49" cy="14" r="1.2" fill="#9deffb" />
    <path d="M30 8 L26 1 h8 Z" fill="#8fa5c9" />
    <path d="M30 22 L26 29 h8 Z" fill="#8fa5c9" />
  </svg>
);

export const ShipViz = ({ total, boost }) => {
  const progress = Math.min(total / FUEL_GOAL, 1);
  const km = Math.round(384400 * (1 - progress));
  const [pop, setPop] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    setPop(true);
    const t = setTimeout(() => setPop(false), 750);
    return () => clearTimeout(t);
  }, [total]);

  return (
    <div
      data-testid="ship-visualization"
      className={`corner-tick relative h-[340px] overflow-hidden border border-[#1c2740] bg-[#050810] sm:h-[380px] ${boost ? "viz-boost" : ""}`}
    >
      <div className="stars" />
      <div className="stars2" />
      <div className="stars3" />
      {boost && <div className="burst-flash absolute inset-0 z-10" />}

      <div className="mono absolute left-4 top-3 z-20 text-[10px] tracking-[0.25em] text-slate-500">
        TELEMETRY <span className="text-gmh-cyan">{"//"}</span> SECTOR 7
      </div>
      <div className="mono absolute right-4 top-3 z-20 flex items-center gap-2 text-[10px] tracking-[0.2em] text-slate-500">
        <span className={`h-1.5 w-1.5 rounded-full ${boost ? "bg-gmh-orange blink-fast" : "bg-gmh-cyan blink"}`} />
        {boost ? "THRUST BURN" : "LIVE"}
      </div>

      {/* trajectory */}
      <div className="absolute left-[6%] right-[6%] top-1/2 border-t border-dashed border-[#22304f]" />
      <div
        className="absolute left-[6%] top-1/2 h-px bg-gradient-to-r from-gmh-orange/70 to-gmh-cyan/70 shadow-[0_0_8px_rgba(53,224,240,0.5)] transition-all duration-[1600ms]"
        style={{ width: `calc(${progress * 76}% )`, transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}
      />

      {/* Earth */}
      <div className="absolute right-[4%] top-1/2 -translate-y-1/2">
        <div className="earth-ring absolute inset-0 rounded-full border border-gmh-cyan/40" />
        <div className="earth h-20 w-20 sm:h-24 sm:w-24" />
        <div className="mono mt-3 text-center text-[9px] tracking-[0.3em] text-slate-500">HOME</div>
      </div>

      {/* Ship */}
      <div
        className="ship-track absolute top-1/2 z-20 -translate-y-1/2"
        style={{ left: `calc(4% + ${progress * 68}%)` }}
      >
        <div className="ship-bob relative">
          <div className="speedlines absolute -inset-x-16 -inset-y-4">
            <span className="speedline left-0 top-1 w-16" />
            <span className="speedline left-4 top-6 w-12" style={{ animationDelay: "0.18s" }} />
            <span className="speedline left-2 bottom-1 w-14" style={{ animationDelay: "0.32s" }} />
          </div>
          <Ship />
          <div className="mono absolute -top-6 left-1/2 -translate-x-1/2 whitespace-nowrap text-[9px] tracking-[0.25em] text-gmh-cyan">
            SAM-01
          </div>
        </div>
      </div>

      {/* bottom readout */}
      <div className="absolute inset-x-0 bottom-0 z-20 border-t border-[#141d34] bg-[#060a13]/80 px-4 py-3 backdrop-blur-sm">
        <div className="mono mb-2 flex items-center justify-between text-[10px] tracking-[0.2em]">
          <span className="text-slate-500">
            DISTANCE TO HOME: <span className="text-slate-200">{km.toLocaleString()} km</span>
          </span>
          <span data-testid="fuel-progress-percent" className={`text-gmh-cyan ${pop ? "value-pop" : ""}`}>
            FUEL {(progress * 100).toFixed(1)}%
          </span>
        </div>
        <div className="h-1.5 overflow-hidden rounded-full bg-[#101a30]">
          <div
            className="h-full rounded-full bg-gradient-to-r from-gmh-orange via-gmh-orange to-gmh-cyan shadow-[0_0_10px_rgba(255,122,47,0.6)] transition-all duration-[1600ms]"
            style={{ width: `${progress * 100}%`, transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}
          />
        </div>
      </div>
    </div>
  );
};